import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=ea22457c&"
import script from "./cards.vue?vue&type=script&lang=js&"
export * from "./cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports